import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useState, useEffect, forwardRef } from "react";
import { clsx } from "@creditornot/cb-utils";
import { Spinner } from "@creditornot/cbc-progress";
import "./style.css";
const root$2 = "cb_FadeTransition_root_rb7i";
const FadeTransition = ({
  children,
  show
}) => {
  const [render, setRender] = useState(show);
  useEffect(() => {
    if (show) {
      setRender(true);
    }
  }, [show]);
  return render ? /* @__PURE__ */ jsx("div", {
    className: root$2,
    "data-show": show ? "" : void 0,
    onAnimationEnd: () => {
      if (!show) {
        setRender(false);
      }
    },
    style: {
      opacity: show ? 1 : 0
    },
    children
  }) : null;
};
const buttonSizeConfigs = {
  small: {
    minHeight: 36,
    spinnerSize: "small"
  },
  medium: {
    minHeight: 46,
    spinnerSize: "medium"
  },
  large: {
    minHeight: 54,
    spinnerSize: "medium"
  }
};
const iconContainer$2 = "cb_Button_iconContainer_i7yn";
const spinnerContainer = "cb_Button_spinnerContainer_s1ii";
const bg$1 = "cb_Button_bg_bb3n";
const content = "cb_Button_content_c1dl";
const root$1 = "cb_Button_root_r1yk";
const Button = React.forwardRef(({
  children,
  className,
  disabled,
  icon: Icon,
  loading = false,
  size = "large",
  stretch = false,
  type = "button",
  variant = "blue",
  ...rest
}, ref) => {
  return /* @__PURE__ */ jsxs("button", {
    "aria-busy": loading,
    className: clsx(root$1, className),
    "data-loading": loading ? "" : void 0,
    "data-size": size,
    "data-stretch": stretch ? "" : void 0,
    "data-variant": variant,
    disabled,
    ref,
    type,
    ...rest,
    children: [/* @__PURE__ */ jsx("div", {
      className: bg$1
    }), /* @__PURE__ */ jsx("div", {
      className: spinnerContainer,
      children: /* @__PURE__ */ jsx(FadeTransition, {
        show: loading,
        children: /* @__PURE__ */ jsx(Spinner, {
          size: buttonSizeConfigs[size].spinnerSize,
          styleParams: {
            color: "currentColor"
          }
        })
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: content,
      children: [!!Icon && /* @__PURE__ */ jsx("div", {
        className: iconContainer$2,
        children: /* @__PURE__ */ jsx(Icon, {})
      }), children]
    })]
  });
});
Button.displayName = "Button";
const bg = "cb_IconButton_bg_b1nm";
const root = "cb_IconButton_root_r1x5";
const iconContainer$1 = "cb_IconButton_iconContainer_inoe";
const IconButton = forwardRef((props, ref) => {
  const {
    backdrop = "transparent",
    className,
    icon: Icon,
    size = "medium",
    type = "button",
    variant = "lightBlue",
    ...rest
  } = props;
  return /* @__PURE__ */ jsxs("button", {
    className: clsx(root, className),
    "data-backdrop": backdrop,
    "data-size": size,
    "data-variant": variant,
    ref,
    type,
    ...rest,
    children: [/* @__PURE__ */ jsx("div", {
      className: bg
    }), /* @__PURE__ */ jsx("div", {
      className: iconContainer$1,
      children: /* @__PURE__ */ jsx(Icon, {})
    })]
  });
});
IconButton.displayName = "IconButton";
const rootCss = "cb_TextButton_rootCss_r1vf";
const iconContainer = "cb_TextButton_iconContainer_i1xp";
const TextButtonContent = ({
  children,
  icon: Icon,
  iconPosition
}) => /* @__PURE__ */ jsxs(Fragment, {
  children: [!!Icon && iconPosition === "start" && /* @__PURE__ */ jsx("span", {
    className: iconContainer,
    "data-position": iconPosition,
    children: /* @__PURE__ */ jsx(Icon, {})
  }), children, !!Icon && iconPosition === "end" && /* @__PURE__ */ jsx("span", {
    className: iconContainer,
    "data-position": iconPosition,
    children: /* @__PURE__ */ jsx(Icon, {})
  })]
});
const TextButton = React.forwardRef((props, ref) => {
  const {
    children,
    className,
    disabled,
    disableTextSelect = false,
    fontFamily = "default",
    icon,
    iconPosition = "start",
    size = "small",
    type = "button",
    variant = "blue",
    wrap = false,
    ...rest
  } = props;
  return /* @__PURE__ */ jsx("button", {
    className: clsx(className, rootCss),
    "data-disable-text-select": disableTextSelect ? "" : void 0,
    "data-font-family": fontFamily,
    "data-prevent-text-wrap": wrap ? void 0 : "",
    "data-size": size,
    "data-variant": variant,
    disabled,
    ref,
    type,
    ...rest,
    children: /* @__PURE__ */ jsx(TextButtonContent, {
      icon,
      iconPosition,
      children
    })
  });
});
TextButton.displayName = "TextButton";
const TextButtonLink = React.forwardRef((props, ref) => {
  const {
    children,
    className,
    disableTextSelect = false,
    fontFamily = "default",
    icon,
    iconPosition = "start",
    size = "small",
    variant = "brand",
    wrap = true,
    ...rest
  } = props;
  return /* @__PURE__ */ jsx(
    "a",
    {
      className: clsx(className, rootCss),
      "data-disable-text-select": disableTextSelect ? "" : void 0,
      "data-font-family": fontFamily,
      "data-prevent-text-wrap": wrap ? void 0 : "",
      "data-size": size,
      "data-variant": variant,
      ref,
      ...rest,
      children: /* @__PURE__ */ jsx(TextButtonContent, { icon, iconPosition, children })
    }
  );
});
TextButtonLink.displayName = "TextButtonLink";
export {
  Button,
  IconButton,
  TextButton,
  TextButtonLink
};
//# sourceMappingURL=index.js.map
